import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.currentTab = 'work_schedule';

    this.styleElement = document.getElementById('dynamic-print-style');
    console.log('styleElement', this.styleElement)
    if (!this.styleElement) {
      this.styleElement = document.createElement('style');
      this.styleElement.id = 'dynamic-print-style';
      document.head.appendChild(this.styleElement);
    }

    this.updatePrintClass();
  }

  disconnect() {
    if (this.styleElement) {
      this.styleElement.remove();
      this.styleElement = null;
    }
  }

  submitForm() {
    clearTimeout(this.timeout);
    document.getElementById('filterForm').requestSubmit();
  }

  debounceSubmit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.submitForm();
    }, 400);
  }

  updatePrintClass() {
    document.documentElement.classList.remove('print-work_schedule', 'print-appearance', 'print-attendance');
    document.documentElement.classList.add(`print-${this.currentTab}`);

    document.body.classList.remove('print-work_schedule', 'print-appearance', 'print-attendance');
    document.body.classList.add(`print-${this.currentTab}`);

    if (this.styleElement) {
      const orientation = this.currentTab === 'work_schedule' ? 'portrait' : 'landscape';
      this.styleElement.innerHTML = `@media print { @page { size: A4 ${orientation}; margin: 10mm; } }`;
    }
  }

  setActiveTab(event) {
    const tab = event.currentTarget.dataset.tab;
    document.querySelectorAll('.tab').forEach(b => b.classList.toggle('active', b.dataset.tab === tab));
    document.querySelectorAll('.report').forEach(r => r.classList.remove('active'));
    document.getElementById(`report-${tab}`).classList.add('active');
    this.currentTab = tab;
    this.updatePrintClass();
  }

  restoreTab() {
    document.querySelectorAll('.report').forEach(r => r.classList.remove('active'));
    const report = document.getElementById(`report-${this.currentTab}`);
    if (report) report.classList.add('active');
  }

  printReport() {
    this.updatePrintClass();
    window.print();
  }
}
